import {
  AUDUSD,
  BTC,
  ETH,
  EURUSD,
  GOLD,
  NZDUSD,
  USDCAD,
  USDCHF,
  USDTHB,
  WTI,
} from "../constants/asset_logo";
import { TimerRange } from "../types/models/AssetSymbol";

export const getSymbolLogo = (symbol: string, logo?: string): string => {
  if (logo) {
    return logo;
  } else {
    switch (symbol) {
      case "USDCAD":
        return USDCAD;
      case "USDAUD":
        return AUDUSD;
      case "USDEUR":
        return EURUSD;
      case "USDTHB":
        return USDTHB;
      case "USDNZD":
        return NZDUSD;
      case "USDCHF":
        return USDCHF;
      case "BTCUSD":
        return BTC;
      case "ETHUSD":
        return ETH;
      case "XAUUSD":
        return GOLD;
      case "WTI":
        return WTI;
      default:
        return "";
    }
  }
};

export const convertTimerRangeToSeconds = (timerRange: TimerRange): number => {
  switch (timerRange) {
    case "1m":
      return 60000;
    case "15m":
      return 60000 * 15;
    default:
      return 60000;
  }
};
